import React, { useState, useEffect } from "react";
import { apiList } from "../../../helpers/apiList";
import CustomAlert from "../../../helpers/CustomAlert";
import { axiosPostApi } from "../../../helpers/interceptorServices";
import AddVectorIcon from "../../../assets/Icons/Add Vector.png";
import CrossIcon from "../../../assets/Icons/cross_svg.svg";
import LeftCircle from "../../../assets/Icons/Left circle B.png";
import RightCircle from "../../../assets/Icons/Right circle A.png";
import Dropdown from "../../../components/Dropdown";
import ModalInput from "../../../components/ModalInput/ModalInput";

const AddRateCardModal = ({
  show,
  handleClose,
  callApi,
  editData,
  action,
  columnData,
}) => {
  const loggedInUserName = sessionStorage.getItem("username");
  const [formData, setFormData] = useState({
    rateCardName: "",
    status: "",
  });
  const [errors, setErrors] = useState({});
  const isReadOnly = action === "view";

  useEffect(() => {
    if (action === "add") {
      setFormData({
        rateCardName: "",
        status: "",
      });
    } else if (action === "modify" || action === "view") {
      setFormData({
        ...editData,
        rateCardName: columnData?.rateCardName || "",
        status: columnData?.status || "",
      });
    }
    setErrors({});
  }, [show, action, editData, columnData]);

  const validate = () => {
    const newErrors = {};
    if (!formData.status.trim()) {
      newErrors.status = "Please select an status";
    }
    if (!formData.rateCardName.trim()) {
      newErrors.rateCardName = "Rate card name is required";
    }
    return newErrors;
  };

  const handleSubmit = () => {
    const validationErrors = validate();
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      const formattedFormData = {
        ...formData,
        rateCardName: formData.rateCardName.trim(),
        status: formData.status.trim(),
      };
      const apiUrl =
        action === "add"
          ? apiList.CREATE_RATE_CARD_MASTER
          : apiList.MODIFY_RATE_CARD_MASTER;
      const payload = {
        username: loggedInUserName,
        ...(action === "modify" && {
          rateCardId: columnData?.rateCardId || columnData?.id,
        }),
        ...formattedFormData,
      };
      axiosPostApi(apiUrl, payload)
        .then((response) => {
          if (response?.status === 200 && response?.data?.status === true) {
            CustomAlert({
              title: response?.data?.message,
              icon: "success",
              confirmButtonText: "OK",
            });
            callApi(1);
            handleClose();
          } else {
            CustomAlert({
              title: "Failed",
              text: response.data.message,
              icon: "error",
              confirmButtonText: "Retry",
            });
          }
        })
        .catch(() => {
          CustomAlert({
            title: "Error",
            text: "An error occurred while processing your request.",
            icon: "error",
            confirmButtonText: "Retry",
          });
        });
    }
  };

  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1031,
      }}
    >
      <div className="bg-white w-[520px] rounded-[20px] p-6 shadow-lg relative border border-gray-200">
        {/* Header */}
        {/* Decorative Circles (background layer) */}
        <img
          src={LeftCircle}
          alt="leftImg"
          className="absolute left-0 bottom-0 w-[110px] h-[105px] z-0"
        />
        <img
          src={RightCircle}
          alt="rightImg"
          className="absolute right-0 top-0 w-[110px] h-[105px] z-0"
        />
        {/* Header Content (foreground layer) */}
        <div
          className="flex justify-between items-center mb-3 relative z-10 pb-3"
          style={{
            borderBottom: "1px solid #dee2e6",
          }}
        >
          <div className="flex items-center gap-2">
            <img src={AddVectorIcon} alt="Add" className="w-7 h-7" />
            <h2 className="text-lg font-semibold text-[#FF6600]">
              {action === "add"
                ? "Add Rate Card"
                : action === "modify"
                ? "Modify Rate Card"
                : "View Rate Card"}
            </h2>
          </div>
          {/* Close Icon */}
          <img
            src={CrossIcon}
            alt="Close"
            onClick={handleClose}
            className="w-5 h-5 cursor-pointer hover:rotate-90 transition-transform z-20"
          />
        </div>
        {/* Form Fields */}
        <div className="grid grid-cols-2 gap-4">

          {/* Rate Card Name */}
            <div>
                <ModalInput
                    id="rateCardName"
                    label="Rate Card Name"
                    placeholder="Enter rate card name"
                    value={formData.rateCardName}
                    disabled={isReadOnly}
                    onChange={(e) => {
                        setFormData((prev) => ({
                            ...prev,
                            rateCardName: e.target.value,
                        }));
                        setErrors((prev) => ({ ...prev, rateCardName:"" }));
                    }}
                    error={errors.rateCardName}
                 />
            </div>
                    

          <div>
            <Dropdown
                label="Status"
                value={formData.status}
                onChange={(item) => {
                    setFormData((prev) => ({
                          ...prev,
                          status: item.value,
                        }));
                }}
                options={[
                    { value: "ACTIVE", label: "Active" },
                    { value: "INACTIVE",label:"Inactive" },
                ]}
                isRequired
                error={errors.status}
                disabled={isReadOnly}
            />
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-center gap-4 mt-6">
          <button
            onClick={handleClose}
            className="btn btn-back !rounded-[8px] w-[133px] h[33px]"
          >
            Cancel
          </button>
          {!isReadOnly && (
            <button
              onClick={handleSubmit}
              className="btn btn-submit !rounded-[8px] w-[133px] h[33px]"
            >
              {action === "modify" ? "Update" : "Submit"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddRateCardModal;
